import { css } from '@emotion/css';

import { AlignItems, Color, Display, Font, ScreenBreakpoint, Spacing } from '../../../../styles';

export const container = css`
  columns: 2 auto;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    columns: 1;
  }
`;

export const documentLogo = css`
  font-size: 2.125rem;
  ${Spacing.mr12}
  color: ${Color.Brand5};
`;

export const documentLabel = css`
  ${Font.lg}
  color: ${Color.Brand5};
`;

export const documentLink = css`
  ${Display.flex}
  ${AlignItems.center}
  ${Spacing.pt24}
  ${Spacing.pb24}
  width: fit-content;
`;
